import styled from '@emotion/styled';

interface SeperatorProps {
  border?: boolean;
  currentTheme: string;
}

export const Seperator = styled.div<SeperatorProps>`
  padding-top: 20px;
  margin-bottom: 30px;
  background: ${({ border, theme, currentTheme }) =>
    !border
      ? ''
      : `linear-gradient(${theme.colors[currentTheme]}, ${theme.colors[currentTheme]}) bottom left /27px 1px no-repeat, transparent`};
`;
